import React from 'react';
import HoverCard from '../HoverCard';

/** Icône ⓘ discrète : explication au survol (bulle HoverCard), ex. dans un en-tête de colonne. */
export default function InfoTip({ children }) {
  return (
    <HoverCard content={children}>
      <span role="img" aria-label="Information" style={styles.icon}>i</span>
    </HoverCard>
  );
}

const styles = {
  icon: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginLeft: '0.35rem',
    width: '1rem', height: '1rem', borderRadius: '50%', border: '1px solid #8a8f99', color: '#8a8f99',
    fontSize: '0.65rem', fontWeight: 700, fontStyle: 'italic', fontFamily: 'Georgia, serif',
    textTransform: 'none', cursor: 'help', lineHeight: 1,
  },
};
